import { defineComponent as _defineComponent } from 'vue'
import DatasetPanel from '@/components/panels/Dataset-Panel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Lineage-Panel',
  props: {
  urn: { default: null }
},
  emits: ["close"],
  setup(__props, { emit }) {






return { __sfc: true,emit, DatasetPanel }
}

})